import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { SVGEditor } from "./SVGEditor";
import { MapList } from "../tools/MapList";

export class KeyFrameAttributes
{
  attribute:ElementAttribute;
  values:string[]; 

  toString()
  {
    return this.attribute.selector + ": [" + this.values.join( ", " ) + "]";
  }
}


export class SVGKeyFramesBuffer
{
  static readonly attributes:ElementAttribute[] = 
  [
    SVGEditor.style,
    SVGEditor.fill,
    SVGEditor.stroke,
    SVGEditor.x,
    SVGEditor.y,
    SVGEditor.width,
    SVGEditor.height,
    SVGEditor.rx,
    SVGEditor.ry,
    SVGEditor.cx,
    SVGEditor.cy,
    SVGEditor.transform
  ]

  differences:Map<Element,KeyFrameAttributes[]> = new Map<Element,KeyFrameAttributes[]>();

  get( root:SVGElement, others:SVGElement[] )
  {
    console.log( "Get", root, others );
    this.getDifferences( root, others );
  }

  compareHierarchies()
  {

  }

  private iterateChildElements( e:Element, callback:(e:any)=>void )
  {
    if ( ! e || ! e.childNodes )
    {
      console.log( "Has no children:", e );
    }

    for ( let i = 0; i < e.childNodes.length; i++ )
    {
      if ( Node.ELEMENT_NODE !== e.childNodes[ i ].nodeType )
      {
        continue;
      }

      callback( e.childNodes[ i ] as Element );
    }
  }

  private getChildElements( e:Element )
  {

    let elements:Element[] = [];

    if ( ! e )
    {
      console.log( "Element invalid:", e );
      return elements;
    }
    
    this.iterateChildElements( e, ( c ) => elements.push( c ) );
    return elements;
  }

  private getDifferences( root:SVGElement, others:SVGElement[] )
  {
    let styleValues:KeyFrameAttributes[] = null;

    // console.log( "getDifferences", root, others );

    SVGKeyFramesBuffer.attributes.forEach(
      ( att )=>
      {
      
        let value = this.checkDifference( att, root, others );
          
        

        if ( value == null )
        {
          return;
        }

        console.log( att.selector, "Root:", ElementAttribute.id.from( root ), att.from( root ), att.from( others[ 0 ] ), value );

        if ( styleValues == null )
        {
          styleValues = [];
        }

        styleValues.push( value );

      }
    );

    let rootElements = this.getChildElements( root );
    let otherElements:Element[][] = [];

    others.forEach( o => otherElements.push( this.getChildElements( o ) ) ); 
    
    for ( let i = 0; i < rootElements.length; i++ )
    {
      let childRootElement = rootElements[ i ] as SVGElement; 
      let childOtherElements:Element[] = [];
      otherElements.forEach( co => childOtherElements.push( co[ i ] ) );

      this.getDifferences( childRootElement, childOtherElements as SVGElement[] );
    }

    if ( ! styleValues || styleValues.length == 0 )
    {
      return;
    }

    this.differences.set( root, styleValues );

    

  }

  private checkDifference( att:ElementAttribute, root:SVGElement, others:SVGElement[] ):KeyFrameAttributes
  { 
    let all = [ root ].concat( others );
    let values:string[] = [];
    let numNulls = 0;
    let counter = 0;

    all.forEach( e => 
      {
        if ( ! e )
        {
          console.log( "Element is null:", counter, all );         
        }

        counter++;

        if ( ! e || ! att.in( e ) )
        {
          
          numNulls++;
          values.push( null );
          return;
        }

        values.push( att.from( e ) );
      }
    )

    if ( numNulls == all.length )
    {
      return null;
    }

    let same = 0;

    for ( let i = 0; i < values.length; i++)
    {
      if ( values[ 0 ] === values[ i ] )
      {
        same++;
      }
    } 

    if ( same == all.length )
    {
      return null;
    }

    let stylingValue = new KeyFrameAttributes();    
    stylingValue.attribute = att;
    stylingValue.values = values;
    return stylingValue;
  }
}